import { WorkspaceSizeThresholds } from "@/common/constants";
import {
	makeStyles,
	shorthands,
	tokens,
	typographyStyles,
} from "@fluentui/react-components";

export const useStyle = makeStyles({
	container: {
		height: "100%",
		width: "100%",
		position: "relative",
		backgroundColor: tokens.colorNeutralBackground1Hover,
		...shorthands.overflow("hidden"),
		containerName: "workspacePanel",
		containerType: "inline-size",
		...shorthands.overflow("unset"),
	},
	interactionBarContainer: {
		position: "relative",
		height: "100%",
		width: "100%",
		minHeight: "0px",
	},
	fixedButton: {
		border: `0.5px solid ${tokens.colorNeutralBackground6}`,
		borderRadius: tokens.borderRadiusSmall,
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		position: "absolute",
	},
	resetToDefaultPosition: {
		top: "3px",
		right: "3px",

		[`@container workspacePanel (width > ${WorkspaceSizeThresholds.Medium}px)`]:
			{
				display: "none",
			},
	},
	backToListButtonPosition: {
		top: "8px",
		left: "8px",
	},
	tab: {
		padding: "3px 10px",
		border: "1px solid lightgray",
	},
	headerTitle: {
		...typographyStyles.body1Stronger,
	},
	tabList: {
		margin: "0px 5px",
	},
	newInteractionContainer: {
		backgroundColor: tokens.colorNeutralBackground4,
		position: "unset",
	},
});
